import { UserRole } from '@reenstudio/app/core/enum/user-role';

const allRoles = [
  UserRole.SITE,
  UserRole.CER,
  UserRole.ADMIN,
  UserRole.INTRAPRESA,
];
const adminsCer = [UserRole.CER, UserRole.ADMIN, UserRole.INTRAPRESA];

export interface FilterConfig {
  name: string;
  userLevel: string[];
  show: boolean;
}

export const filterConfigs: { [page: string]: FilterConfig[] } = {
  '/history': [
    {
      name: 'filterTitle',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'periodType',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'periodValue',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'monthList',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'yearList',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'customRange',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'site',
      userLevel: adminsCer,
      show: true,
    },
    {
      name: 'filterButton',
      userLevel: allRoles,
      show: true,
    },
  ],
  '/forecast': [
    {
      name: 'filterTitle',
      userLevel: adminsCer,
      show: true,
    },
    {
      name: 'periodType',
      userLevel: allRoles,
      show: false,
    },
    {
      name: 'periodValue',
      userLevel: allRoles,
      show: false,
    },
    {
      name: 'monthList',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'yearList',
      userLevel: allRoles,
      show: false,
    },
    {
      name: 'customRange',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'site',
      userLevel: adminsCer,
      show: true,
    },
    {
      name: 'filterButton',
      userLevel: adminsCer,
      show: true,
    },
  ],
  '/incentive/calculate': [
    {
      name: 'filterTitle',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'periodType',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'periodValue',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'monthList',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'yearList',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'customRange',
      userLevel: allRoles,
      show: true,
    },
    {
      name: 'site',
      userLevel: adminsCer,
      show: true,
    },
    {
      name: 'filterButton',
      userLevel: allRoles,
      show: true,
    },
  ],
};
